import { makeStyles } from "../theme";

const useStyles = makeStyles(
  () => ({
    spacer: {
      flex: "1",
    },
  }),
  { name: "Savebar" }
);

export default useStyles;
